var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMarcas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.036,
    height: 20.118,
    viewBox: "0 0 121.036 20.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M0-100H57.243v19.145H0Z",
    transform: "translate(0 100)",
    fill: "#e7e7e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    "data-name": "Grupo 442",
    transform: "translate(-1274.256 -25.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1274.256 26.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M0,6.556c.016-.65.055-2.241.084-3.179a3.264,3.264,0,0,1,.74-2.37C1.466.4,2.214.255,4,.151A99.976,99.976,0,0,1,17.633.338a1.6,1.6,0,0,1,.865.23c.233.171.263.362.325,1.36.036.571.108,2.1.146,2.934-1.821-.1-4.912-.269-7.6-.3s-5.117.017-5.4.056a1.275,1.275,0,0,0-.938.5L19,7.884v2.173Z",
    transform: "translate(0 0)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M0,14l19,3.63c-.013.53-.055,2.211-.087,3.175a3.071,3.071,0,0,1-.74,2.283c-.641.584-1.389.724-3.176.824A103.828,103.828,0,0,1,1.362,23.73,1.639,1.639,0,0,1,.5,23.509C.263,23.344.234,23.16.172,22.2.13,21.556.039,19.656.01,19.028c2.449.17,6.212.294,9.279.294.77,0,2.772.025,3.3.025a1.448,1.448,0,0,0,1.261-.572L0,16.35Z",
    transform: "translate(0 -6.178)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Audi_Rings_Medium_wh-RGB",
    transform: "translate(1302.535 25.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audi_Rings_Medium_wh-RGB-2",
    "data-name": "Audi_Rings_Medium_wh-RGB",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M47.67-82.125a8.266,8.266,0,0,1-5.458-2.054,9.528,9.528,0,0,0,2.331-6.249,9.528,9.528,0,0,0-2.331-6.249,8.266,8.266,0,0,1,5.458-2.054,8.312,8.312,0,0,1,8.3,8.3,8.313,8.313,0,0,1-8.3,8.3M29.513-84.178a9.528,9.528,0,0,0,2.331-6.249,9.528,9.528,0,0,0-2.331-6.249,8.266,8.266,0,0,1,5.458-2.054,8.265,8.265,0,0,1,5.458,2.054A9.529,9.529,0,0,0,38.1-90.428a9.528,9.528,0,0,0,2.331,6.249,8.265,8.265,0,0,1-5.458,2.054,8.266,8.266,0,0,1-5.458-2.054m-12.7,0a9.527,9.527,0,0,0,2.331-6.249,9.528,9.528,0,0,0-2.331-6.249,8.265,8.265,0,0,1,5.458-2.054,8.266,8.266,0,0,1,5.458,2.054A9.528,9.528,0,0,0,25.4-90.428a9.527,9.527,0,0,0,2.331,6.249,8.266,8.266,0,0,1-5.458,2.054,8.265,8.265,0,0,1-5.458-2.054M1.269-90.428a8.312,8.312,0,0,1,8.3-8.3,8.265,8.265,0,0,1,5.458,2.054A9.529,9.529,0,0,0,12.7-90.428a9.528,9.528,0,0,0,2.331,6.249,8.265,8.265,0,0,1-5.458,2.054,8.313,8.313,0,0,1-8.3-8.3m14.653,5.342a8.264,8.264,0,0,1-1.954-5.342,8.264,8.264,0,0,1,1.954-5.342,8.265,8.265,0,0,1,1.953,5.342,8.265,8.265,0,0,1-1.953,5.342m12.7,0a8.265,8.265,0,0,1-1.954-5.342,8.265,8.265,0,0,1,1.954-5.342,8.265,8.265,0,0,1,1.954,5.342,8.265,8.265,0,0,1-1.954,5.342m12.7,0a8.265,8.265,0,0,1-1.953-5.342,8.265,8.265,0,0,1,1.953-5.342,8.265,8.265,0,0,1,1.954,5.342,8.265,8.265,0,0,1-1.954,5.342M47.67-100a9.532,9.532,0,0,0-6.35,2.418A9.531,9.531,0,0,0,34.971-100a9.532,9.532,0,0,0-6.35,2.418A9.532,9.532,0,0,0,22.272-100a9.531,9.531,0,0,0-6.35,2.418A9.532,9.532,0,0,0,9.572-100,9.583,9.583,0,0,0,0-90.428a9.583,9.583,0,0,0,9.572,9.572,9.532,9.532,0,0,0,6.35-2.418,9.531,9.531,0,0,0,6.35,2.418,9.532,9.532,0,0,0,6.35-2.418,9.532,9.532,0,0,0,6.35,2.418,9.531,9.531,0,0,0,6.35-2.418,9.532,9.532,0,0,0,6.35,2.418,9.583,9.583,0,0,0,9.572-9.572A9.583,9.583,0,0,0,47.67-100",
    transform: "translate(0 100)",
    fill: "#e7e7e7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path8-4",
    d: "M1103.111,963.354l-4.247,2.078h0l2.589.993a2.122,2.122,0,0,1,1.4,1.1,1.961,1.961,0,0,1-.424,1.713l-1.419,2.213q-2.517,3.94-5.036,7.871v-2.433h0q.966-3.041,1.877-6.081.258-.868.511-1.735a.52.52,0,0,0-.3-.724l-2.583-1.271-2.572,1.269a.518.518,0,0,0-.3.724q.252.87.511,1.735.909,3.053,1.877,6.081h0v2.433q-2.523-3.934-5.035-7.871l-1.419-2.213a1.921,1.921,0,0,1-.424-1.713,2.09,2.09,0,0,1,1.4-1.1l2.589-.993h0l-4.247-2.078h0l1.324,2.22-2.189.842q-2.3-3.6-4.6-7.213c4.359,1.545,8.717,3.1,13.088,4.6,4.376-1.494,8.729-3.051,13.088-4.6q-2.291,3.606-4.593,7.2l-2.189-.842,1.324-2.22",
    transform: "translate(286.717 -933.549)",
    fill: "#e7e7e7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarcas);
export default __webpack_public_path__ + "static/media/logo-marcas.654422c224c21328cb0eb16e96a834b3.svg";
export { ForwardRef as ReactComponent };